// utils/loadGoogleMaps.ts
let googleMapsLoadingPromise: Promise<void> | null = null;

export const loadGoogleMaps = (apiKey: string): Promise<void> => {
  if (typeof window === "undefined") {
    // Server-side rendering
    return Promise.resolve();
  }

  if (window.google?.maps?.places) {
    // Already loaded
    return Promise.resolve();
  }

  if (!googleMapsLoadingPromise) {
    googleMapsLoadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => {
        googleMapsLoadingPromise = null;
        reject(new Error("Failed to load Google Maps script"));
      };
      document.head.appendChild(script);
    });
  }

  return googleMapsLoadingPromise;
};
